var React = require('react');

function CheckipClose (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4.31787","y":"3.56055","width":"17.1429","height":"1.07143","transform":"rotate(45 4.31787 3.56055)","fill":"white","key":0}),React.createElement("rect",{"x":"3.56006","y":"15.6816","width":"17.1429","height":"1.07143","transform":"rotate(-45 3.56006 15.6816)","fill":"white","key":1})]);
}

CheckipClose.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheckipClose;

CheckipClose.default = CheckipClose;
